import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export type SearchQuery = { [k: string]: string }

const useQuery = () => {
  const { search } = useLocation()
  const urlSearchParams = useMemo(() => new URLSearchParams(search), [search])
  const query = useMemo<SearchQuery>(() => {
    const q: SearchQuery = {}
    for (const p of urlSearchParams) {
      q[p[0]] = p[1]
    }
    return q
  }, [urlSearchParams])
  return query
}

export default useQuery
